import Decimal from "decimal.js";
import { roundNumber } from ".";

export const addValues = (values) => {
  if (values.length === 0) return 0;
  if (values.length === 1) return new Decimal(values[0] || 0).toNumber();

  return values
    .reduce(
      (total, value) => total.add(new Decimal(value || 0)),
      new Decimal(0),
    )
    .toNumber();
};

export const subtractValues = (values) => {
  if (values.length === 0) return 0;
  if (values.length === 1) return new Decimal(values[0] || 0).toNumber();

  return values
    .slice(1)
    .reduce(
      (total, value) => total.sub(new Decimal(value || 0)),
      new Decimal(values[0] || 0),
    )
    .toNumber();
};

export const multiplyValues = (values) => {
  if (values.length === 0) return 0;
  if (values.length === 1) return new Decimal(values[0] || 0).toNumber();

  return values
    .reduce(
      (total, value) => total.mul(new Decimal(value || 0)),
      new Decimal(1),
    )
    .toNumber();
};

export const divideValues = (values) => {
  if (!values.length) return 0;

  let total = new Decimal(values[0] ?? 0);

  for (let i = 1; i < values.length; i++) {
    const divisor = new Decimal(values[i] ?? 0);

    if (divisor.isZero()) {
      console.error("Divide by zero occurred");
      return 0; // if 0, return 0
    }

    total = total.div(divisor);
  }

  return total.toNumber();
};

export const isValidNumber = (value) => {
  return (
    typeof value === "number" ||
    (typeof value === "string" && value.trim() !== "" && !isNaN(value))
  );
};

export const roundNearestInt = (value) => {
  return createDecimal(value).round().toNumber();
};

export const createDecimal = (value) => {
  if (!isValidNumber(value)) {
    return new Decimal(0);
  }

  return new Decimal(value);
};

export const itemQuantity = (
  payment_value,
  item_total,
  item_total_quantity,
) => {
  return roundNumber(
    createDecimal(payment_value)
      .div(createDecimal(item_total))
      .mul(createDecimal(item_total_quantity))
      .toNumber(),
  );
};

export const generatePercentage = (loaded, total) => {
  return createDecimal(divideValues([loaded, total]))
    .mul(100)
    .floor()
    .toNumber();
};

export const roundAndMultiply = (value, multiply = 100) => {
  return roundNearestInt(multiplyValues([value, multiply]));
};
